import React, { FC } from 'react';
import { CheckboxGroup } from 'react-uforms';
import { Option, Question } from '@ch/common/types/data';
import { FormCheckboxGroupItem } from '@ch/common/components/form/checkbox';
import { Box } from '@ch/common/components/box';
import { quizFieldOptionProps } from './const';
import QuizTooltip from '@ch/common/components/quiz-tooltip/quiz-tooltip';

const QuizFieldCheckbox: FC<Question> = ({ identifier: name, disabled, options }) => {
  return (
    <CheckboxGroup name={name} disabled={disabled} hideError>
      {options?.length > 0 &&
        options.map(({ option: label, identifier: value, tooltip }: Option) => (
          <Box key={value} {...quizFieldOptionProps}>
            <FormCheckboxGroupItem value={value}>
              <span dangerouslySetInnerHTML={{ __html: label }} />
              {tooltip && <QuizTooltip id={value}>{tooltip}</QuizTooltip>}
            </FormCheckboxGroupItem>
          </Box>
        ))}
    </CheckboxGroup>
  );
};

export default QuizFieldCheckbox;
